import { combineReducers } from '@reduxjs/toolkit';
import { reducer as calendarReducer } from 'src/slices/calendar';
import { reducer as chatReducer } from 'src/slices/chat';
// @ts-ignore
import { reducer as formReducer } from 'redux-form';
import { reducer as kanbanReducer } from 'src/slices/kanban';
import { reducer as mailReducer } from 'src/slices/mail';
import { reducer as notificationReducer } from 'src/slices/notification';
import { reducer as postsReducer } from 'src/slices/posts';
import { reducer as homeReducer } from 'src/slices/home';
import { reducer as recipeReducer } from 'src/slices/recipes';

const rootReducer = combineReducers({
  calendar: calendarReducer,
  chat: chatReducer,
  form: formReducer,
  kanban: kanbanReducer,
  mail: mailReducer,
  notifications: notificationReducer,
  posts: postsReducer,
  home: homeReducer,
  recipe: recipeReducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
